"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalRuleConfig = void 0;
var classnames_1 = __importDefault(require("classnames"));
exports.HorizontalRuleConfig = {
    publicRender: function (_a) {
        var attributes = _a.attributes;
        return "<hr class=\"".concat((0, classnames_1.default)(attributes.className), "\" />");
    },
    tokenType: {},
    type: "horizontalRule",
    traits: {
        spacingShim: {
            className: "horizontal-rule-widget__spacing-shim",
        },
        selection: {
            ringMode: "hugging",
            ringBorderRadius: 4
        }
    },
};
